import React, { useEffect, useRef } from "react";
import {
    HubConnection,
    HubConnectionBuilder,
    HttpTransportType,
    LogLevel,
} from "@microsoft/signalr";

// export interface ISignalRComponentProps {
//     processMessage: (signalR: any) => void;
//     groupId?: string;
// }

export interface ISignalRComponentProps {
    processMessage: (signalR: any) => void;
    groupId?: string;
    onConnected?: () => void;       // Poll document statuses on initial connect
    onReconnected?: () => void;     // Poll document statuses after reconnect
}

const retryDelaysMs: number[] = [0, 2000, 5000, 10000, 30000];

const buildHubUrl = (): string => {
    const baseUrl = process.env.REACT_APP_HACHET_API_BASE_URL || "";
    const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
    return `${normalizedBaseUrl}notification`;
};

const SignalRComponent = (signalRProps: ISignalRComponentProps) => {
    const connectionRef = useRef<HubConnection | null>(null);

    useEffect(() => {
        let disposed = false;

        const stopConnection = async () => {
            const existingConnection = connectionRef.current;
            connectionRef.current = null;

            if (existingConnection) {
                try {
                    await existingConnection.stop();
                } catch (err) {
                    console.error("SignalR stop failed", err);
                }
            }
        };

        const startConnection = async () => {
            if (!signalRProps.groupId) {
                return;
            }

            const connection = new HubConnectionBuilder()
                .withUrl(buildHubUrl(), {
                    transport: HttpTransportType.WebSockets,
                    accessTokenFactory: () => signalRProps.groupId || "",
                })
                .withAutomaticReconnect(retryDelaysMs)
                .configureLogging(LogLevel.Information)
                .build();

            const onReceiveMessage = (documentId: string, operationStatus: string) => {
                signalRProps.processMessage({
                    documentId,
                    operationStatus,
                });
            };

            connection.on("ReceiveMessage", onReceiveMessage);

            connection.onreconnecting((err) => {
                console.warn("SignalR reconnecting", err);
            });

            connection.onreconnected((connectionId) => {
                console.info("SignalR reconnected", connectionId);
                // Re-poll status after reconnection to catch missed messages
                if (signalRProps.onReconnected) {
                    signalRProps.onReconnected();
                }
            });

            connection.onclose((err) => {
                if (!disposed) {
                    console.warn("SignalR closed, will retry in 60s", err);
                    setTimeout(() => {
                        if (!disposed) {
                            void startConnection();
                        }
                    }, 60000);
                }
            });

            connectionRef.current = connection;

            try {
                await connection.start();
                console.info("SignalR connected");
                // Poll current status immediately after connecting
                // to catch messages sent before the connection was established
                if (signalRProps.onConnected) {
                    signalRProps.onConnected();
                }
            } catch (err) {
                console.error("SignalR connection failed to start", err);
                connection.off("ReceiveMessage", onReceiveMessage);
                await connection.stop();
                if (connectionRef.current === connection) {
                    connectionRef.current = null;
                }
            }
        };

        (async () => {
            await stopConnection();

            if (!disposed) {
                await startConnection();
            }
        })();

        return () => {
            disposed = true;
            void stopConnection();
        };
    }, [signalRProps.groupId, signalRProps.processMessage]);

    return null;
};

// const SignalRComponent = (signalRProps: ISignalRComponentProps) => {
//     const connectionRef = useRef<HubConnection | null>(null);

//     useEffect(() => {
//         let disposed = false;

//         const stopConnection = async () => {
//             const existingConnection = connectionRef.current;
//             connectionRef.current = null;

//             if (existingConnection) {
//                 try {
//                     await existingConnection.stop();
//                 } catch (err) {
//                     console.error("SignalR stop failed", err);
//                 }
//             }
//         };

//         const startConnection = async () => {
//             if (!signalRProps.groupId) {
//                 return;
//             }

//             const connection = new HubConnectionBuilder()
//                 .withUrl(buildHubUrl(), {
//                     transport: HttpTransportType.WebSockets,
//                     accessTokenFactory: () => signalRProps.groupId || "",
//                 })
//                 .withAutomaticReconnect(retryDelaysMs)
//                 .configureLogging(LogLevel.Information)
//                 .build();

//             const onReceiveMessage = (documentId: string, operationStatus: string) => {
//                 signalRProps.processMessage({
//                     documentId,
//                     operationStatus,
//                 });
//             };

//             connection.on("ReceiveMessage", onReceiveMessage);

//             connection.onreconnecting((err) => {
//                 console.warn("SignalR reconnecting", err);
//             });

//             connection.onreconnected((connectionId) => {
//                 console.info("SignalR reconnected", connectionId);
//             });

//             connection.onclose((err) => {
//                 if (!disposed) {
//                     console.warn("SignalR closed", err);
//                 }
//             });

//             connectionRef.current = connection;

//             try {
//                 await connection.start();
//                 console.info("SignalR connected");
//             } catch (err) {
//                 console.error("SignalR connection failed to start", err);
//                 connection.off("ReceiveMessage", onReceiveMessage);
//                 await connection.stop();
//                 if (connectionRef.current === connection) {
//                     connectionRef.current = null;
//                 }
//             }
//         };

//         (async () => {
//             await stopConnection();

//             if (!disposed) {
//                 await startConnection();
//             }
//         })();

//         return () => {
//             disposed = true;
//             void stopConnection();
//         };
//     }, [signalRProps.groupId, signalRProps.processMessage]);

//     return null;
// };

export default SignalRComponent;

// import React, { useEffect } from "react";
// import {
//     HubConnection,
//     HubConnectionBuilder,
//     HubConnectionState,
//     HttpTransportType,
//     LogLevel,
// } from "@microsoft/signalr";

// export interface ISignalRComponentProps {
//     processMessage: (signalR: any) => void;
//     groupId?: string;
// }

// const retryDelaysMs: number[] = [0, 2000, 5000, 10000, 30000];

// const buildHubUrl = (): string => {
//     const baseUrl = process.env.REACT_APP_HACHET_API_BASE_URL || "";
//     const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
//     return `${normalizedBaseUrl}notification`;
// };

// const SignalRComponent = (signalRProps: ISignalRComponentProps) => {
//   const connectionRef = React.useRef<HubConnection | null>(null);
//   const groupIdRef = React.useRef(signalRProps.groupId);

//   // Keep groupIdRef updated with the latest groupId
//   React.useEffect(() => {
//     groupIdRef.current = signalRProps.groupId;
//   }, [signalRProps.groupId]);

//   React.useEffect(() => {
//     let disposed = false;

//     const cleanupConnection = async () => {
//       if (connectionRef.current) {
//         await connectionRef.current.stop();
//         connectionRef.current = null;
//       }
//     };

//     const hubUrl = buildHubUrl();
//     console.log('buildHubUrl', hubUrl);

//     const startConnection = async () => {
//       const connection = new HubConnectionBuilder()
//         .withUrl(buildHubUrl(), {
//           transport: HttpTransportType.WebSockets,
//           accessTokenFactory: () => groupIdRef.current, // Use the latest groupId from the ref
//         })
//         .withAutomaticReconnect()
//         .configureLogging(LogLevel.Information)
//         .build();

//       connectionRef.current = connection;

//       const onReceiveMessage = (msg: unknown) => {
//         signalRProps.processMessage(msg);
//       };

//       connection.on("ReceiveMessage", onReceiveMessage);

//       try {
//         await connection.start();
//       } catch (err) {
//         if (!disposed) {
//           console.error("SignalR connection failed to start", err);
//           setTimeout(startConnection, 5000); // Retry connection
//         }
//       }

//       return () => {
//         disposed = true;
//         connection.off("ReceiveMessage", onReceiveMessage);
//         void connection.stop();
//       };
//     };

//     (async () => {
//       await cleanupConnection();
//       if (!disposed) {
//         await startConnection();
//       }
//     })();

//     return () => {
//       disposed = true;
//       cleanupConnection();
//     };
//   }, [signalRProps.processMessage]); // Only re-run if processMessage changes

//   return null;
// };

// export default SignalRComponent;
